const currencyData = require('../assets/data/currencyData');

function formatCurrency (value, currencyCode, decimalPlacesOverride) {
  if (isNaN(value)){
    return '';
  }
  let currencyDataItem = currencyData[currencyCode.toLowerCase()];
  if (currencyDataItem) {
    value = parseFloat(value);
    value = roundNumber(value, (!Number.isNaN(decimalPlacesOverride) ? decimalPlacesOverride : currencyDataItem.precision));
    value = currencyDataItem.format.replace('__price__', value.toFixed(!Number.isNaN(decimalPlacesOverride) ? decimalPlacesOverride : currencyDataItem.precision));
  }
  return value;
}

function currencySymbol(currencyCode) {
  if (currencyCode && currencyCode.length === 3) {
    let currencyDataItem = currencyData[currencyCode.toLowerCase()];
    return currencyDataItem.format.replace('__price__', '');
  }
  return '';
}

function roundNumber(num, scale) {
  if (Math.round(num) != num) {
    if (Math.pow(0.1, scale) > num) {
      return 0;
    }
    var sign = Math.sign(num);
    var arr = ("" + Math.abs(num)).split(".");
    if (arr.length > 1) {
      if (arr[1].length > scale) {
        var integ = +arr[0] * Math.pow(10, scale);
        var dec = integ + (+arr[1].slice(0, scale) + Math.pow(10, scale));
        var proc = +arr[1].slice(scale, scale + 1)
        if (proc >= 5) {
          dec = dec + 1;
        }
        dec = sign * (dec - Math.pow(10, scale)) / Math.pow(10, scale);
        return dec;
      }
    }
  }
  return num;
}

export default {formatCurrency, currencySymbol};